(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9839],{

/***/ 60922:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/self-assessment",
      function () {
        return __webpack_require__(13992);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 47460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);



var SeoTags = function(props) {
    if (!(props === null || props === void 0 ? void 0 : props.config)) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            props.config.title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: props.config.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: props.config.title
                    })
                ]
            }) : null,
            props.config.description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: props.config.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: props.config.description
                    })
                ]
            }) : null,
            props.config.keywords ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: props.config.keywords
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: "//casehub.pro/og.png"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SeoTags);


/***/ }),

/***/ 13992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_SeoTags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47460);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_forms_AssessmentForm__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86714);
/* harmony import */ var _util_auth__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19475);
/* harmony import */ var _util_assessment__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21757);
/* harmony import */ var _components_ui_typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58020);
/* harmony import */ var _util_hooks_useAssessment__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19084);
/* harmony import */ var _util_hooks_useStableCallback__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(80995);
/* harmony import */ var _components_ui_tabs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(35895);
/* harmony import */ var _components_ui_card__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(64345);
/* harmony import */ var _components_ui_button__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(35739);














function SelfAssessment() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var auth = (0,_util_auth__WEBPACK_IMPORTED_MODULE_5__/* .useAuth */ .aC)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), formSections = ref[0], setFormSections = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        (0,_util_assessment__WEBPACK_IMPORTED_MODULE_6__/* .fetchAssessmentQuestions */ .zT)().then(function(response) {
            if (response && response.length) {
                setFormSections(response);
            }
        }).catch(console.error);
    }, []);
    var ref1 = (0,_util_hooks_useAssessment__WEBPACK_IMPORTED_MODULE_8__/* .useAssessment */ .Y)({
        storageKey: "assessment-form",
        formSections: formSections,
        tabsCount: 3
    }), handleChange = ref1.onChange, formData = ref1.formData, isValidForm = ref1.isValidForm, answers = ref1.answers, clearAnswers = ref1.clearAnswers, hasPreviousSection = ref1.hasPreviousSection, hasNextSection = ref1.hasNextSection, setCurrentTab = ref1.setCurrentTab, currentTab = ref1.currentTab, progress = ref1.progress, sectionsByExpertise = ref1.sectionsByExpertise;
    var handleSubmit = (0,_util_hooks_useStableCallback__WEBPACK_IMPORTED_MODULE_9__/* .useStableCallback */ .R)(function() {
        if (!isValidForm) {
            return;
        }
        if (auth.isAuthenticated) {
            (0,_util_assessment__WEBPACK_IMPORTED_MODULE_6__/* .postSelfAssessment */ .X9)(formData).then(function() {
                clearAnswers();
                router.push("/self-assessment-result");
            }).catch(console.error);
        }
        router.push("/self-assessment-result");
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SeoTags__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                config: {
                    title: "Self-assessment"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex mt-6 mb-16",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full max-w-screen lg:w-1/2 m-auto",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_typography__WEBPACK_IMPORTED_MODULE_7__/* .Typography */ .Z, {
                                    variant: "h2",
                                    className: "mb-3",
                                    children: "Self-assessment"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "text-sm mb-6",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "mb-2",
                                                    children: "Please use the scale 1 – 10, where:"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                                            children: "1-2"
                                                        }),
                                                        ": Strongly disagree"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                                            children: "3-4"
                                                        }),
                                                        ": Disagree"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                                            children: "5-6"
                                                        }),
                                                        ": Neutral"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                                            children: "7-8"
                                                        }),
                                                        ": Agree"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                                            children: "9-10"
                                                        }),
                                                        ": Strongly agree"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "mt-2",
                                                    children: "Takes 15 minutes to complete, get your score immediately, and choose the right strategy for your training program."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_forms_AssessmentForm__WEBPACK_IMPORTED_MODULE_4__/* .FormProgressBar */ .Z, {
                                            steps: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(progress.map(function(step, index) {
                                                return {
                                                    active: Number(currentTab) === index,
                                                    completed: step.completed
                                                };
                                            }))
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_tabs__WEBPACK_IMPORTED_MODULE_10__/* .Tabs */ .mQ, {
                                            value: currentTab,
                                            onValueChange: function(value) {
                                                setCurrentTab(value);
                                            },
                                            children: sectionsByExpertise.map(function(expertise, index) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_tabs__WEBPACK_IMPORTED_MODULE_10__/* .TabsContent */ .nU, {
                                                    value: String(index),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "flex justify-between items-center p-6 top-[98px] z-10",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_typography__WEBPACK_IMPORTED_MODULE_7__/* .Typography */ .Z, {
                                                                variant: "h5",
                                                                children: expertise.title
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_card__WEBPACK_IMPORTED_MODULE_11__/* .Card */ .Zb, {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_card__WEBPACK_IMPORTED_MODULE_11__/* .CardHeader */ .Ol, {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_card__WEBPACK_IMPORTED_MODULE_11__/* .CardTitle */ .ll, {})
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_card__WEBPACK_IMPORTED_MODULE_11__/* .CardContent */ .aY, {
                                                                    className: "space-y-2",
                                                                    children: expertise.questions.map(function(question) {
                                                                        var ref;
                                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_forms_AssessmentForm__WEBPACK_IMPORTED_MODULE_4__/* .AssessmentFormQuestion */ .T, {
                                                                            selectedScore: (ref = answers[question.id]) === null || ref === void 0 ? void 0 : ref.score,
                                                                            question: question,
                                                                            onChange: function(param) {
                                                                                var value = param.value, checked = param.checked;
                                                                                handleChange({
                                                                                    id: question.id,
                                                                                    score: value,
                                                                                    checked: checked,
                                                                                    expertise_id: question.expertise_id
                                                                                });
                                                                            }
                                                                        }, question.id);
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_card__WEBPACK_IMPORTED_MODULE_11__/* .CardFooter */ .eW, {
                                                                    className: "justify-between",
                                                                    children: [
                                                                        hasPreviousSection ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_button__WEBPACK_IMPORTED_MODULE_12__/* .Button */ .z, {
                                                                            variant: "outline",
                                                                            size: "sm",
                                                                            onClick: function() {
                                                                                setCurrentTab(String(Number(currentTab) - 1));
                                                                            },
                                                                            children: "Back"
                                                                        }) : null,
                                                                        hasNextSection ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_button__WEBPACK_IMPORTED_MODULE_12__/* .Button */ .z, {
                                                                            variant: "outline",
                                                                            size: "sm",
                                                                            className: "ml-auto",
                                                                            onClick: function() {
                                                                                setCurrentTab(String(Number(currentTab) + 1));
                                                                            },
                                                                            children: "Next"
                                                                        }) : null,
                                                                        !hasNextSection ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_button__WEBPACK_IMPORTED_MODULE_12__/* .Button */ .z, {
                                                                            size: "sm",
                                                                            onClick: handleSubmit,
                                                                            disabled: !isValidForm,
                                                                            children: "Submit assessment"
                                                                        }) : null
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, expertise.id);
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (SelfAssessment);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7147,9774,2888,179], function() { return __webpack_exec__(60922); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);